import { Phone, MessageCircle } from "lucide-react";
import { BUSINESS } from "@/lib/site";

// Tasteful sticky bottom bar on mobile only. Does not obstruct desktop content.
export function MobileContactBar() {
  return (
    <div
      data-testid="mobile-contact-bar"
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-border bg-white/95 backdrop-blur-lg lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a
        href={`tel:${BUSINESS.phoneTel}`}
        data-testid="bar-call-button"
        className="flex items-center justify-center gap-2 py-4 text-sm font-medium text-charcoal"
      >
        <Phone className="h-4 w-4 text-brand" /> Call
      </a>
      <a
        href={BUSINESS.whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="bar-whatsapp-button"
        className="flex items-center justify-center gap-2 border-l border-border bg-brand py-4 text-sm font-medium text-white"
      >
        <MessageCircle className="h-4 w-4" /> WhatsApp
      </a>
    </div>
  );
}
